export default __webpack_public_path__ + "static/media/press-hero.6f6f4580.png";